import { RootState } from 'handlers';

export const getGoalProgressState = (state: RootState) => ({
  goalProgress: state.reports.goalProgress,
  isLoading: state.reports.isGoalProgressLoading,
  isError: state.reports.isGoalProgressError,
});
